import { Component, Input } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

/**
 * Small "i" button that explains a field on demand.
 *
 * Replaces the standing helper captions that sat under inputs. Those captions
 * cost permanent vertical space, are read once and then tuned out, and push the
 * actual content down the page. A hint the user opens when they want it keeps
 * the explanation available without paying for it on every render.
 *
 * Usage:
 *   <info-hint title="Skills" text="..."></info-hint>
 */
@Component({
	selector: 'info-hint',
	templateUrl: './info-hint.component.html',
	styleUrls: ['./info-hint.component.scss'],
	imports: [NgbPopover]
})
export class InfoHintComponent {
	/** Heading shown at the top of the hint. */
	@Input() title: string = '';
	/** The explanation itself. */
	@Input() text: string = '';
	/** Screen-reader label; falls back to something sensible. */
	@Input() label: string = '';

	get ariaLabel(): string {
		return this.label || (this.title ? `About ${this.title}` : 'More information');
	}
}
